import BannersContainer from 'components/ads/BannersContainer'
import Header from 'components/landing/Header'
import PageMeta from 'components/base/PageMeta'
import { FC, c } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { withUserProps } from 'lib/contextCreation'
import { GetServerSideProps } from 'next'
import Button from 'components/base/Button'
import Link from 'components/base/Link'
import LandingPromoContainer from 'components/ads/LandingPromoContainer'
import botImage from '@/public/next/img/landing/bot.webp'
import botImage1x from '@/public/next/img/landing/bot-1x.png'
import botImage2x from '@/public/next/img/landing/bot-2x.png'
import { useIntl } from 'lib/intl-utils'
import LandingSignupForm from 'components/landing/sellmonitor/blocks/LandingSignupForm'
import Container from 'components/landing/Container'
// import { getRepricerTableRows, repricerTableColumns } from '../lib/repricerTable'
import Testimonials from 'components/landing/sellmonitor/blocks/Testimonials'
import SellersCases from 'components/landing/sellmonitor/blocks/SellersCases'
import SellersLogos from 'components/landing/sellmonitor/blocks/SellersLogos'
import Tooltip from 'components/base/Tooltip'
import onecLogo from '@/public/next/img/landing/partners/logo1c.png'
import wbLogo from '@/public/next/img/landing/partners/wb.svg'
import mincifriLogo from '@/public/next/img/landing/partners/mincifri.svg'
import { getCanonicalHref } from 'lib/canonical'
import SchemaMarkup from 'components/base/SchemaMarkup'
import { getBreadcrumbSchema, getOrganizationSchema, getFAQPageSchema } from 'lib/schema-utils'
import Faq, { FaqItem } from 'components/landing/sellmonitor/blocks/Faq'

// const columnWidthById = {
//   'checks-per-hour': 'w-28 min-w-28 max-w-28',
//   tariffs: 'w-28 min-w-28 max-w-28',
//   'price-1000': 'w-28 min-w-28 max-w-28',
//   'in-subscription': 'w-36 min-w-36 max-w-36',
// }

const faqs: FaqItem[] = [
  {
    question: 'Что такое автоматическое управление ценами и как оно помогает на маркетплейсах?',
    answer:
      'Это инструмент, также известный как репрайсер, который сам меняет цену товара в зависимости от выбранных сценариев: по маржинальности, фиксированной цене, расписанию, конкурентам или остаткам, и помогает быстрее реагировать на изменения, повышая эффективность продаж.',
  },
  {
    question: 'Как учитываются цены конкурентов?',
    answer:
      'Инструмент анализирует цены выбранных конкурентов на маркетплейсах и автоматически корректирует цену по заданной стратегии. Например, можно удерживать цену ниже других или оставаться в определённом диапазоне.',
  },
  {
    question: 'Можно ли настроить стратегию изменения цен?',
    answer:
      'Да. Доступны стратегии: по маржинальности, по конкурентам, по расписанию, по остаткам или фиксированной цене. Вы задаёте сценарии и их порядок, а система применяет первый подходящий в зависимости от условий.',
  },
  {
    question: 'Что такое автоакция и можно ли в ней не участвовать?',
    answer:
      'Автоакция – это автоматическая скидка от маркетплейса. Чтобы в ней не участвовать, используйте сценарий «Фиксированная цена»: сервис каждую минуту проверяет цену и корректирует её до заданной, даже если маркетплейс включил скидку.',
  },
  {
    question: 'Подходит ли этот инструмент для Wildberries и Ozon?',
    answer: 'Да. Инструмент работает с Wildberries и Ozon и учитывает особенности каждой площадки.',
  },
  {
    question: 'Нужно ли вручную менять цены на товары при использовании управления ценами?',
    answer:
      'Нет, наш инструмент полностью автоматизирует изменение цен. Вам не нужно вручную обновлять цену товара – система делает это за вас по заданным правилам.',
  },
]

export const getServerSideProps: GetServerSideProps = withUserProps(
  async ({ pageContext, userContext }) => {
    if (!['sellmonitor', 'sellematics'].includes(userContext.theme.hostType)) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        isResponsive: true,
      },
    }
  },
  { forceUnauthorizedMode: true }
)

const RepricerLandingPage: FC = () => {
  const ctx = useUserContext()
  const { t, format, lang } = useIntl()
  const organizationSchema = getOrganizationSchema(ctx)
  const breadcrumbSchema = getBreadcrumbSchema(ctx, [
    {
      name: 'Управление ценами на Wildberries и Ozon',
      url: `${ctx.theme.canonicalURL}/repricer/`,
    },
  ])
  const canonicalHref = getCanonicalHref(ctx.theme.canonicalURL, '/repricer/')
  const faqPageSchema = getFAQPageSchema(faqs)

  // const tableRows = getRepricerTableRows(format) as ReturnType<typeof getRepricerTableRows>

  return (
    <>
      <PageMeta
        title="Изменение цен на маркетплейсах | Автоматическое управление стоимости товаров (репрайсер) на Wildberries и Ozon в Sellmonitor"
        description="Узнайте, как автоматизировать управление ценами на маркетплейсах: Ozon и Wildberries. Получите бесплатный доступ к инструменту автоматического изменения стоимости товаров (репрайсеру)."
        canonical={canonicalHref}
        image={`${ctx.theme.canonicalURL}/next/img/landing/repricer_social_media_preview.png`}
      />
      <SchemaMarkup schema={organizationSchema} id="organization-schema" />
      <SchemaMarkup schema={breadcrumbSchema} id="breadcrumb-schema" />
      <SchemaMarkup schema={faqPageSchema} id="faq-page-schema" />

      <LandingPromoContainer />
      <BannersContainer scope="landing" placement="repricer" />
      <Header />

      <div className="relative overflow-hidden bg-white isolate">
        <div className="px-6 pt-10 pb-12 mx-auto max-w-7xl sm:pb-24 lg:py-20 lg:px-8">
          <div className="lg:flex">
            <div className="max-w-2xl mx-auto lg:mx-0 lg:max-w-xl lg:flex-shrink-0 lg:pt-10">
              <h1
                className={c`text-4xl [@media_(min-width:480px)_and_(max-width:640px)]:text-5xl sm:text-6xl -ml-0.5 [font-variation-settings:'wdth'_150,'wght'_650] tracking-tight text-gray-900
								${lang === 'zh'} !leading-tight
							`}
              >
                Управление ценами на Wildberries и Ozon
              </h1>
              <p className="mt-6 text-lg text-gray-600">
                Каждую минуту проверяем реальную цену на ваши товары в любом регионе РФ и
                автоматически меняем её на нужную в зависимости от маржинальности, остатков, времени
                суток или цен конкурентов
              </p>
              <div className="grid grid-rows-2 mt-12 gap-y-4 gap-x-6 w-fit sm:flex">
                <Button
                  as={Link}
                  href="#signup"
                  theme="accent"
                  className="w-fit transition-shadow !px-6 !py-3 !text-base !rounded-lg hover:!bg-lime-300 hover:!brightness-105 hover:[box-shadow:0_0_48px_5px_theme(colors.lime.300)]"
                >
                  {t`landing.try_for_free`}
                </Button>
              </div>
            </div>
            <div className="hidden max-w-2xl mx-auto mt-16 lg:ml-10 lg:-mt-4 lg:mr-0 lg:max-w-none lg:flex-none xl:ml-24 lg:flex">
              <div className="flex-none max-w-3xl sm:max-w-5xl lg:max-w-none">
                <div className={c`block p-2 -m-2 lg:-m-12`}>
                  <picture>
                    <source
                      media="(min-width: 1024px) and (min-resolution: 2.5dppx)"
                      srcSet={botImage.src}
                      type="image/webp"
                    />
                    <source
                      media="(min-width: 1024px)"
                      srcSet={`${botImage1x.src} 864w, ${botImage2x.src} 1728w`}
                      sizes="864px"
                      type="image/png"
                    />
                    <img
                      src={botImage1x.src}
                      alt="Репрайсер Sellmonitor - робот автоматически меняет цены на товары"
                      width={botImage.width}
                      height={botImage.height}
                      className="w-[54rem]"
                      loading="eager"
                    />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Container className="!pt-4 !pb-20">
        <div className="flex flex-col items-start w-full">
          <ul className="flex flex-row flex-wrap w-full gap-3 lg:max-w-7xl">
            {[
              'Как не участвовать в автоакциях?',
              'Как постоянно держать цену ниже конкурентов?',
              'Как автоматически менять цены у тысячи товаров?',
              'Как мгновенно повысить цену, если товар заканчивается?',
              'Как удерживать нужную маржинальность вне зависимости от скидок и расходов?',
            ].map((item) => (
              <li
                key={item}
                className="inline-flex flex-col items-start px-4 py-2 text-base font-medium bg-white border rounded-full md:text-lg text-primary-700 border-primary-600 w-fit flex-nowrap"
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </Container>

      <Container className="!pt-4 !pb-20">
        <h2 className="text-3xl font-medium text-left">Что такое управление ценами?</h2>
        <p className="max-w-5xl mt-2 text-lg text-gray-700">
          Как продавец, в личном кабинете маркетплейса вы можете менять у товара цену без скидки и
          со скидкой. Но покупатели видят не эту цену, а цену с дополнительной скидкой от
          маркетплейса, которая может меняться.
        </p>
        <p className="max-w-5xl mt-2 text-lg text-gray-700">
          Управление ценами Sellmonitor, или репрайсер, будет контролировать за вас реальную цену,
          которую видят покупатели.
        </p>
        <ul className="grid grid-cols-6 gap-6 mt-8">
          {[
            {
              icon: '⚡',
              title: 'Мониторим цены раз в минуту',
              description:
                'Проверяем каждый товар каждую минуту. Сразу же реагируем на любые отклонения и исправляем их',
            },
            {
              icon: '👀',
              title: 'Контролируем реальную цену',
              description:
                'Следим за ценой со всеми скидками маркетплейса, которую видит и оплачивает покупатель',
            },
            {
              icon: '🤖',
              title: 'Управляем тысячами товаров',
              description:
                'Вручную управлять тысячами товаров невозможно. Мы делаем это за вас 24 / 7',
            },
          ].map((item) => (
            <li
              key={item.title}
              className="flex flex-col col-span-6 gap-2 p-6 border border-primary-200 bg-primary-50 lg:col-span-2 rounded-xl"
            >
              <h3 className="text-xl font-medium text-black">
                <span className="mr-3 text-2xl">{item.icon}</span>
                {item.title}
              </h3>
              <p className="text-base text-left text-primary-950/80">{item.description}</p>
            </li>
          ))}
        </ul>
      </Container>

      <Container className="!bg-primary-50 !py-20">
        <h2 className="text-3xl font-medium text-left">Сценарии и настройки управления ценами</h2>
        <p className="max-w-5xl mt-2 text-lg text-gray-700">
          Сценарий — это правило, по которому сервис обновляет цену. Можно настроить несколько
          сценариев и указать порядок. Применяется первый подходящий по порядку сценарий.
        </p>
        <ul className="grid grid-cols-12 gap-6 mt-8">
          {[
            {
              icon: '💰',
              title: 'Сценарий «По маржинальности»',
              description:
                'Рассчитаем цену так, чтобы товар продавался с указанной маржинальностью. Увеличилась комиссия или расходы на логистику? Повысим цену. Уменьшился процент СПП или соинвеста? Изменим цену так, чтобы вы продолжали зарабатывать. Учитываем реальные расходы с маркетплейса, налоги и себестоимость товаров.',
              className: '!bg-lime-200 !text-lime-950/90 sm:!col-span-12 md:!col-span-6',
            },
            {
              icon: '📌',
              title: 'Сценарий «Фиксированная цена»',
              description:
                'Удержим заданную цену, даже если включится автоакция или поменяется размер скидки. Каждую минуту проверяем цены, если выбранные товары попадают в автоакцию или изменилась скидка маркетплейса, сразу корректируем цену. Так покупатели всегда будут видеть указанную вами цену.',
              className: '!bg-indigo-100 !text-indigo-900/90 sm:!col-span-12 md:!col-span-6',
            },
            {
              icon: '⏰',
              title: 'Сценарий «По расписанию»',
              description:
                'Применим указанную цену в выбранные часы и дни недели. Например, будем повышать цену в будние дни после 18 часов, когда покупатели более активны.',
            },
            {
              icon: '🥊',
              title: 'Сценарий «По конкурентам»',
              description:
                'Скорректируем цены ваших товаров относительно цены товаров конкурентов. Например, будем удерживать цену ниже всех конкурентов, чтобы покупатели выбирали ваш товар.',
            },
            {
              icon: '🔗',
              title: 'Сценарий «Кросс-маркетплейс»',
              description:
                'Скорректируем цену относительно цены вашего товара на другой площадке. Например, будем удерживать цену на Ozon на том же уровне, что и на Wildberries.',
            },
            {
              icon: '📦',
              title: 'Сценарий «По остаткам»',
              description:
                'Поменяем цену в зависимости от количества товара на складе. Например, если товар заканчивается, повысим цену, чтобы его не раскупили до новой поставки.',
            },
            {
              icon: '💎',
              title: 'Красивая цена',
              description:
                'Автоматически применим указанное окончание ко всем ценам. Например, все цены будут заканчиваться на 99.',
            },
            {
              icon: '📣',
              title: 'Управление акциями',
              description:
                'Подберём акции в пределах допустимого снижения цены. Например, на Ozon выберем акцию с максимальным бустингом для продвижения товара в выдаче.',
            },
            {
              icon: '⚙️',
              title: 'Массовая настройка товаров',
              description:
                'Меняйте настройки сразу у группы товаров — в интерфейсе или через Excel. Объединяйте товары тегами и обновляйте только нужные параметры, сохраняя остальные настройки.',
              className: 'sm:!col-span-12 md:!col-span-12',
            },
          ].map((item) => (
            <li
              key={item.title}
              className={c`flex flex-col gap-2 col-span-12 p-6 text-gray-900 sm:col-span-6 md:col-span-6 rounded-xl bg-white ${item.className}`}
            >
              <h3 className="text-xl font-medium !text-black">
                <span className="mr-3 text-2xl">{item.icon}</span>
                {item.title}
              </h3>
              <p className="text-base text-left">{item.description}</p>
            </li>
          ))}
        </ul>
      </Container>

      <Container className="!pb-0">
        <h2 className="text-3xl font-medium text-left">
          ⚡ Управление ценами Sellmonitor быстрее всех
        </h2>
        <p className="max-w-5xl mt-2 text-lg text-gray-700">
          Проверяем цены ваших товаров каждую минуту — намного чаще, чем другие сервисы.
        </p>
        <ul className="grid grid-cols-6 gap-6 mt-8">
          {[
            {
              icon: '📣',
              title: 'Автоакция и скидка маркетплейса',
              description:
                'Любое отклонение от заданной цены, включение автоакции или изменение скидки маркетплейса, исправим за минуту, чтобы не продавать товар по низкой цене',
            },
            {
              icon: '🚚',
              title: 'Остатки на складе',
              description:
                'Быстро узнаем об изменении остатка на складе и сразу же повысим цены на ваши товары, чтобы их не раскупили до новой поставки',
            },
            {
              icon: '🔎',
              title: 'Цены товаров конкурентов',
              description:
                'Заметим, что конкуренты снизили цену, и оперативно скорректируем цены на ваши товары, чтобы они всегда были дешевле',
            },
            {
              icon: '🚀',
              title: 'Изменение настроек',
              description:
                'Новые настройки и сценарии управления ценами начнут работать уже через минуту, чтобы вы смогли сразу начать проверять новую стратегию',
            },
          ].map((item) => (
            <li
              key={item.title}
              className="flex flex-col col-span-6 gap-2 p-6 border border-purple-200 bg-purple-50 sm:col-span-3 rounded-xl"
            >
              <h3 className="text-xl font-medium text-black">
                <span className="mr-3 text-2xl">{item.icon}</span>
                {item.title}
              </h3>
              <p className="text-base text-left text-purple-950/80">{item.description}</p>
            </li>
          ))}
        </ul>
      </Container>

      <Container className="!pt-12">
        <div className="relative mx-auto overflow-hidden text-base text-white rounded-2xl bg-gradient-to-tr from-gray-900 to-gray-700 selection:bg-gray-700">
          <div className="relative w-full px-8 py-4">
            <h2 className="flex items-center gap-2 text-lg font-medium">
              <img src="/img/mall_ico/beru.png" alt="Логотип Яндекс Маркета" className="inline size-6" />
              <span className="">Скоро: управление ценами для Яндекс Маркета</span>
            </h2>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024"
              className="absolute -top-[200%] -right-[48rem] lg:-right-[26rem] z-10 min-h-[64rem] min-w-[64rem] h-[64rem] w-[64rem]"
              aria-hidden="true"
            >
              <circle
                cx={512}
                cy={512}
                r={512}
                fill="url(#repricer-yellow-gradient)"
                fillOpacity="1"
              />
              <defs>
                <radialGradient
                  id="repricer-yellow-gradient"
                  cx={0}
                  cy={0}
                  r={1}
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(512 512) rotate(90) scale(512)"
                >
                  <stop stopColor="#FFDD04" />
                  <stop offset={1} stopColor="#FFDD04" stopOpacity={0} />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>
      </Container>

      <Container className="!pt-0">
        <h2 className="text-3xl font-medium text-left">🛡️ Цены под тройной защитой</h2>
        <p className="max-w-5xl mt-2 text-lg text-gray-700">
          Прежде чем отправить цену на маркетплейс, репрайсер проверяет её с трёх сторон
        </p>
        <ul className="grid grid-cols-3 gap-6 mt-8">
          {[
            {
              title: 'Защита от ошибок в настройках',
              items: [
                {
                  icon: '🔒',
                  title: 'Минимальная цена',
                  description: 'Репрайсер никогда не опустит цену ниже вашего минимума',
                },
                {
                  icon: '💰',
                  title: 'Минимальная маржинальность',
                  description:
                    'Не снижаем цену, если маржинальность окажется ниже заданного вами минимума',
                },
                {
                  icon: '🪂',
                  title: 'Страховочный порог',
                  description:
                    'Даже если минимум указан по ошибке, слишком низкая цена не будет установлена',
                },
                {
                  icon: '✅',
                  title: 'Проверка настроек',
                  description: 'Ошибочные или противоречивые настройки не получится сохранить',
                },
              ],
            },
            {
              title: 'Защита от сбоев маркетплейса',
              items: [
                {
                  icon: '🔍',
                  title: 'Сверка с витриной',
                  description:
                    'Сверяем данные маркетплейса с витриной, чтобы задержки и сбои не повлияли на цену',
                },
                {
                  icon: '🧮',
                  title: 'Проверка логики цен',
                  description:
                    'Если маркетплейс показывает странные цены, репрайсер не будет на них опираться',
                },
                {
                  icon: '🚫',
                  title: 'Фильтр ошибочных данных',
                  description: 'Пустые и явно неверные значения отбрасываются до расчёта',
                },
              ],
            },
            {
              title: 'Защита от ошибок в расчётах',
              items: [
                {
                  icon: '🔁',
                  title: 'Контроль на каждом шаге',
                  description: 'Каждый этап расчёта перепроверяет предыдущий',
                },
                {
                  icon: '🏁',
                  title: 'Финальная проверка',
                  description: 'Перед отправкой каждая цена проходит обязательный контроль',
                },
              ],
            },
          ].map((group, index) => (
            <li
              key={group.title}
              className="flex flex-col col-span-3 gap-4 p-6 border border-emerald-200 bg-emerald-50 lg:col-span-1 rounded-xl"
            >
              <h3 className="flex items-start text-[19px] leading-7 font-medium text-black">
                <span className="inline-flex items-center justify-center flex-none mt-px mr-3 text-[15px] font-semibold text-white rounded-full size-[26px] bg-emerald-600">
                  {index + 1}
                </span>
                {group.title}
              </h3>
              <ul className="flex flex-col gap-4">
                {group.items.map((item) => (
                  <li key={item.title} className="flex flex-col gap-1 text-base">
                    <span className="font-medium text-emerald-950">
                      <span className="mr-2">{item.icon}</span>
                      {item.title}
                    </span>
                    <span className="text-emerald-950/80">{item.description}</span>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <p className="max-w-5xl mt-6 text-lg text-gray-700">
          Если хоть одна проверка не пройдена, цена не меняется — лучше пропустить изменение, чем
          поставить неправильную цену
        </p>
      </Container>

      <Container className="!pt-0">
        <div className="flex flex-col items-start w-full">
          <h2 className="max-w-full text-3xl font-medium text-left lg:max-w-5xl">
            Почему нам можно доверять?
          </h2>

          <div className="grid grid-cols-2 gap-3 mt-12 w-fit lg:grid-cols-4">
            <div className="flex flex-col items-start gap-4 px-3 pt-2 pb-3 rounded-lg bg-gray-200/50">
              <h3 className="text-sm font-medium">Товаров под управлением репрайсера</h3>
              <div className="flex items-end flex-1">
                <p className="text-4xl font-medium leading-none">247 000+</p>
              </div>
            </div>
            <Tooltip
              sizing="text"
              content="Компания 1С владеет 51% долей ООО «Селлематикс», которая делает Sellmonitor"
            >
              <div className="flex flex-col items-start gap-4 px-3 pt-2 pb-3 rounded-lg bg-gray-200/50">
                <h3 className="text-sm font-medium">Часть экосистемы</h3>
                <div className="flex items-end flex-1">
                  <img
                    src={onecLogo.src}
                    alt="Логотип 1С"
                    width={onecLogo.width}
                    height={onecLogo.height}
                    loading="lazy"
                    className="w-auto h-8"
                  />
                </div>
              </div>
            </Tooltip>
            <Tooltip
              sizing="text"
              content={
                <div>
                  <div className="font-medium">Авторизованный сервис аналитики Wildberries</div>
                  <div className="mt-0.5">
                    Это значит, что Sellmonitor прошел проверку на соответствие требованиям при
                    работе с личным кабинетом продавца. Можно смело подключаться — Wildberries
                    гарантирует безопасность и соответствие правилам маркетплейса.
                  </div>
                </div>
              }
            >
              <div className="flex flex-col items-start gap-4 px-3 pt-2 pb-3 rounded-lg bg-gray-200/50">
                <h3 className="text-sm font-medium">Официальный авторизованный сервис</h3>
                <div className="flex items-end flex-1">
                  <img
                    src={wbLogo.src}
                    alt="Логотип Wildberries"
                    width={wbLogo.width}
                    height={wbLogo.height}
                    loading="lazy"
                    className="w-auto h-8"
                  />
                </div>
              </div>
            </Tooltip>
            <Tooltip
              sizing="text"
              content={
                <div>
                  <div className="font-medium">Отечественное ПО</div>
                  <div className="mt-0.5">
                    Наша компания аккредитована в Минцифры, а сервис Sellmonitor входит в реестр
                    отечественного ПО. Эксперты министерства проверили соответствие сервиса ряду
                    критериев, к примеру, по информационной безопасности и обеспечению поддержки
                    пользователей.
                  </div>
                </div>
              }
            >
              <div className="flex flex-col items-start gap-4 px-3 pt-2 pb-3 rounded-lg bg-gray-200/50">
                <h3 className="text-sm font-medium">Аккредитованная IT-компания</h3>
                <div className="flex items-end flex-1">
                  <img
                    src={mincifriLogo.src}
                    alt="Логотип Минцифры"
                    width={mincifriLogo.width}
                    height={mincifriLogo.height}
                    loading="lazy"
                    className="w-auto h-9"
                  />
                </div>
              </div>
            </Tooltip>
          </div>
        </div>
      </Container>

      {/* <Container className="!pb-0">
        <div className="space-y-2">
          <h2 className="text-3xl font-medium">Почему выбирают Sellmonitor?</h2>
          <p className="mt-2 text-lg text-gray-700">
            Сравнение тарифов Sellmonitor для управления ценами на Wildberries и Ozon с тарифами
            других сервисов.
            <br />
            Данные взяты из открытых источников.
          </p>
        </div>

        <div className="hidden mt-8 overflow-hidden bg-white border border-gray-200 md:block rounded-2xl">
          <div className="overflow-x-auto xl:overflow-visible">
            <table className="w-full min-w-[973px] xl:min-w-0 table-fixed border-collapse text-left text-sm">
              <thead className="text-gray-900 border-b border-gray-200">
                <tr>
                  <th className="w-24 px-4 py-3 font-normal min-w-24 max-w-24"></th>
                  {repricerTableColumns.map((column) => (
                    <th
                      key={column.id}
                      className={c`px-4 py-3 font-semibold ${
                        columnWidthById[column.id as keyof typeof columnWidthById]
                      }`}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {tableRows.map((row) => (
                  <tr key={row.id} className="text-base text-gray-900 align-top">
                    <td
                      className={`text-base px-4 py-4 font-semibold ${
                        row.id === 'sellmonitor' ? 'bg-primary-50 text-primary-700' : 'bg-white'
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <span>{row.label}</span>
                      </div>
                    </td>
                    {repricerTableColumns.map((column) => {
                      const cell = row.values.find((value) => value.id === column.id)
                      const content = cell?.content ?? '—'

                      return (
                        <td
                          key={`${row.id}-${column.id}`}
                          className={`break-words align-top px-4 py-4 ${
                            row.id === 'sellmonitor'
                              ? 'bg-primary-50 text-primary-700 font-semibold'
                              : ''
                          }`}
                        >
                          {content}
                        </td>
                      )
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 space-y-4 md:hidden">
          {tableRows.map((row) => {
            const isSellmonitor = row.id === 'sellmonitor'
            return (
              <div
                key={row.id}
                className={c`rounded-2xl border overflow-hidden ${isSellmonitor} bg-primary-50 border-primary-200 | border-gray-200 bg-white`}
              >
                <div
                  className={c`px-4 py-3 font-semibold text-base relative ${isSellmonitor} bg-primary-50 text-primary-700`}
                >
                  <div
                    className={c`absolute bottom-0 left-4 right-4 h-px ${isSellmonitor} bg-primary-200 | bg-gray-200`}
                  />
                  {row.label}
                </div>
                <div className="flex flex-col">
                  {repricerTableColumns.map((column) => {
                    const cell = row.values.find((value) => value.id === column.id)
                    const content = cell?.content ?? '—'

                    // Новый объединённый блок "Тарифы" + "+ 1000 товаров"
                    if (column.id === 'tariffs') {
                      const price1000Cell = row.values.find((value) => value.id === 'price-1000')

                      return (
                        <div
                          key={`${row.id}-tariffs-and-1000`}
                          className={c`px-4 py-3 relative ${isSellmonitor} bg-primary-50 text-primary-700`}
                        >
                          <div
                            className={c`absolute top-0 left-4 right-4 h-px ${isSellmonitor} bg-primary-100 | bg-gray-100`}
                          />

                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <div className="mb-1 text-xs font-medium text-gray-500">Тарифы</div>
                              <div className={c`text-base ${isSellmonitor} font-semibold`}>
                                {content}
                              </div>
                            </div>

                            <div>
                              <div className="mb-1 text-xs font-medium text-gray-500">
                                + 1000 товаров
                              </div>
                              <div className={c`text-base ${isSellmonitor} font-semibold`}>
                                {price1000Cell?.content ?? '—'}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }

                    // Не рендерим отдельно price-1000
                    if (column.id === 'price-1000') {
                      return null
                    }

                    return (
                      <div
                        key={`${row.id}-${column.id}`}
                        className={c`px-4 py-3 relative ${isSellmonitor} bg-primary-50 text-primary-700`}
                      >
                        {column !== repricerTableColumns[0] && (
                          <div
                            className={c`absolute top-0 left-4 right-4 h-px ${isSellmonitor} bg-primary-100 | bg-gray-100`}
                          />
                        )}
                        <div className="mb-1 text-xs font-medium text-gray-500">{column.label}</div>
                        <div className={c`text-base ${isSellmonitor} font-semibold | `}>
                          {content}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </Container> */}

      <SellersCases malls={['wb', 'ozon']} className="!py-20" />
      <SellersLogos className="!pt-20" />
      <Testimonials className="!py-0" headingClassName="!text-left !mx-0" />
      <Faq title="Часто задаваемые вопросы" faqs={faqs} className="!pt-20 !pb-0" />

      <LandingSignupForm
        id="signup"
        type="signup"
        className="!py-24 scroll-mt-20"
        title="Получите пробный доступ"
        description="Свяжемся с вами после регистрации и расскажем о сервисе"
      />
    </>
  )
}

export default RepricerLandingPage
